import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.988 22.942S2.4 21.485 2.55 17.73a3.8 3.8 0 0 1 1.089-2.743 3.75 3.75 0 0 1 5.3 5.3 8.84 8.84 0 0 1-7.951 2.655m9.829-12.445 2.642 2.642"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M22.2 1.729a2.77 2.77 0 0 0-4.067.162L7.7 14.163a3.75 3.75 0 0 1 2.087 2.118L22.039 5.8a2.77 2.77 0 0 0 .161-4.071"
    }, null, -1)
  ]));
}
const interfaceEditToolPaintBrush = { render };
export {
  interfaceEditToolPaintBrush as default,
  render
};
//# sourceMappingURL=interface-edit-tool-paint-brush.svg.js.map
